import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Form, Title } from 'components/layout'
import { form } from 'helpers/decorators'
import { Button, FormButton } from 'components/misc'
import { RichTextArea } from 'components/richtext'
import { Checkbox, Input } from 'components/fields'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { modal } from '../../../redux/modules/app'
import { FormattedMessage } from 'react-intl'


const enhance = compose(
    connect(() => ({}),
        {
          modal
        }
    ),
    form({
      form: 'bulk-action-send-message-modal',
      disableHook: true
    })
)

class BulkActionSendMessageModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    modalId: PropTypes.string,
    modal: PropTypes.func,
    itemCount: PropTypes.number.isRequired,
    selectedIds: PropTypes.array,
    sendMessages: PropTypes.func,
    bulkSetResult: PropTypes.func,
    handleError: PropTypes.func,
    initialize:PropTypes.func,
    change: PropTypes.func,
    reset: PropTypes.func
  }

  state = {
      message: true,
      email: false
  }

  componentDidMount() {
      this.props.initialize({ sendAsPushNotification: true, sendAsEmail: false })
  }

    handleBulkSendMessage = fields => {
    this.props.sendMessages({ participantIds: this.props.selectedIds, ...fields })
        .then(data => {
          this.props.bulkSetResult(data.body)
          this.handleCloseModal()
          this.props.modal('bulk-change-participants-results-modal')
         })
        .catch(this.props.handleError)
  }

  handleMsgTypeCheck = (value, type) => {
      switch (type) {
          case 'message': this.setState({ message: value })
              break
          case 'email': this.setState({ email: value })
              break
          default: return
    }
  }

    handleCloseModal = () => {
        this.props.reset()
        this.props.modal(null)
    }

  render() {
    const {
      modalId,
      itemCount,
      handleSubmit
    } = this.props

    return (
        <Modal id={modalId} customActions>
          <Title h2>
              <FormattedMessage
                  id="moduleTitle.send_message_bulk"
                  defaultMessage={`Send a message to ${itemCount} participants.`}
                  values={{
                      itemCount: itemCount
                  }}
              />
          </Title>
          <Form
              className="form"
              onSubmit={handleSubmit(this.handleBulkSendMessage)}
          >
            <div className="row" />
            <Input label="Title" intlKey="label.message_title" name="title" />
            <RichTextArea label="Message" intlKey="label.message" name="content" />
              <div className="col-xs-6">
                <Checkbox
                    label="Message"
                    intlKey="label.message"
                    name="sendAsPushNotification"
                    onChange={value => this.handleMsgTypeCheck(value, 'message')}
                />
              </div>
              <div className="col-xs-6">
                <Checkbox
                    label="Email"
                    intlKey="label.email"
                    name="sendAsEmail"
                    onChange={value => this.handleMsgTypeCheck(value, 'email')}
                />
              </div>
            <div className="row">
              <div className="col-xs-6">
                <Button
                    intlKey="button.cancel"
                    onClick={() => this.handleCloseModal()}
                    secondary
                    type="button"
                    style={{ marginRight: 10 }}
                >
                  Cancel
                </Button>
              </div>
              <div className="col-xs-6 text--right">
                <FormButton
                    {...this.props}
                    intlKey="button.send"
                    disabled={!(this.state.message || this.state.email)}
                >
                  Send
                </FormButton>
              </div>
            </div>
          </Form>
        </Modal>
    )
  }
}

export default enhance(BulkActionSendMessageModal)

